import React from 'react';
import { Header } from 'semantic-ui-react';

const PageHeader = props => (
  <Header className="PageHeader" {...props} as="h2" inverted />
);

export default PageHeader;
